import { render, staticRenderFns } from "./recordsCountSolid.vue?vue&type=template&id=133f3b86&"
import script from "./recordsCountSolid.vue?vue&type=script&lang=js&"
export * from "./recordsCountSolid.vue?vue&type=script&lang=js&"
import style0 from "./recordsCountSolid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports